import { userPaginationCount } from '../../data/Constants';
import { format } from 'date-fns';

const getUserFilterParams = (startCount, searchText, searchableLastOrderTime, searchableNoOrderPlacedInPast, neverOrderedisChecked,
  searchableLastOrderedLocation, searchableHasOrderedCategory, searchableHasOrderedProduct, maxPoints, minPoints, usersSelected) => {
  let queryParams = searchText.length > 0 ? `users?start=${startCount}&count=${usersSelected}&q=${searchText}` : queryParams = `users?start=${startCount}&count=${usersSelected}`;
  let queryFilters = [];
  if (neverOrderedisChecked) {
    queryFilters.push('COUNT(orders)=0');
  } else {
    if (searchableLastOrderTime.length === 1 && searchableLastOrderTime[0].value > 0) {
      const fromDate = convertToAPIDateFormat(searchableLastOrderTime);
      queryFilters.push(`lastOrderTime>${fromDate}`);
    }
    if (searchableNoOrderPlacedInPast.length === 1 && searchableNoOrderPlacedInPast[0].value > 0) {
      const fromDate = convertToAPIDateFormat(searchableNoOrderPlacedInPast);
      queryFilters.push(`-lastOrderTime>${fromDate}`);
    }
    if (searchableLastOrderedLocation.length === 1 && searchableLastOrderedLocation[0].value > 0) {
      queryFilters.push(`lastOrderLocation=${searchableLastOrderedLocation[0].value}`);
    }
    if (searchableHasOrderedCategory && searchableHasOrderedCategory.length > 0) {
      let categories = [];
      searchableHasOrderedCategory.forEach((category) => {
        categories.push(category.value);
      });
      queryFilters.push(`orders.category:${categories.toString()}`);
    }
    if (searchableHasOrderedProduct && searchableHasOrderedProduct.length > 0) {
      let products = [];
      searchableHasOrderedProduct.forEach((product) => {
        products.push(product.value);
      });
      queryFilters.push(`orders.product:${products.toString()}`);
    }
  }
  if (maxPoints) {
    queryFilters.push(`points<=${maxPoints}`);
  }
  if (minPoints && minPoints > 0) {
    queryFilters.push(`points>=${minPoints}`);
  }
  if (queryFilters.length > 0) {
    queryParams += `&filter=${queryFilters.join('AND')}`;
  }
  return queryParams;
};

export { getUserFilterParams };

function convertToAPIDateFormat(rawTime) {
  const timePoint = Date.now() - rawTime[0].value * 1000;
  let time = new Date(timePoint);
  const fromDate = time.toISOString().slice(0, -5) + format(time, 'XXXXX');
  return fromDate;
}
